import type { WavespeedSpeechModelConfig } from '../types';

export const alibabaConfigs: Record<string, WavespeedSpeechModelConfig> = {
    'qwen3-tts-flash': {
        // https://wavespeed.ai/zh-CN/models/alibaba/qwen3-tts-flash
        apiPath: '/alibaba/qwen3-tts-flash',
        enableTranslation: false,
        buildInput: ({ text, voice, providerOptions }) => {
            return {
                text: text,
                voice: voice,
                // system
                language: 'Auto'
            };
        },
    },
    'qwen3-tts': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/qwen3-tts/text-to-speech
        apiPath: '/wavespeed-ai/qwen3-tts/text-to-speech',
        enableTranslation: false,
        buildInput: ({ text, voice, providerOptions }) => {
            return {
                text: text,
                voice: voice,
                style_instruction: providerOptions?.lyrics,
                // system
                language: 'auto'
            };
        },
    },
    'qwen3-voice-clone': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/qwen3-tts/voice-clone
        apiPath: '/wavespeed-ai/qwen3-tts/voice-clone',
        enableTranslation: false,
        buildInput: ({ text, audioUrls }) => {
            return {
                text: text,
                // 音频 URL
                audio: audioUrls?.[0],
                // system
                language: 'auto'
            };
        },
    },
    'qwen3-voice-design': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/qwen3-tts/voice-design
        apiPath: '/wavespeed-ai/qwen3-tts/voice-design',
        enableTranslation: false,
        buildInput: ({ text, providerOptions }) => {
            return {
                text: text,
                voice_description: providerOptions?.lyrics || '',
                // system
                language: 'auto'
            };
        },
    },
};